import clsx from "clsx";
import { ReactNode } from "react";

import styles from "./info-table.module.css";

export function InfoTable(props: { children: ReactNode; userClass?: boolean }) {
  return (
    <table className={clsx(styles.table, props.userClass && styles.userClass)}>
      <tbody>{props.children}</tbody>
    </table>
  );
}
